import bankChinaContruction from '../../banksPNG/bankChinaContruction.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoChinaConstructionIcon = ({
	width = '17',
	height = '17',
	alt = 'Banco Coopeuch',
}: IconProps) => <img src={bankChinaContruction} width={width} height={height} alt={alt} />;
